import { MoreVertical, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import type { CollectionStats } from '../../types';

interface Props {
  collection: CollectionStats;
  onRequestDelete: (collection: CollectionStats) => void;
}

/**
 * Ações da coleção na sidebar. Espelha o DocumentRowMenu: ação destrutiva atrás
 * de um menu, não exposta como ícone solto. Fica como irmão do botão de seleção
 * (nunca aninhado) — `<button>` dentro de `<button>` é HTML inválido.
 */
export function CollectionRowMenu({ collection, onRequestDelete }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          // Sempre visível, discreto, firme no hover. Antes ficava invisível até
          // passar o mouse, então a única forma de remover uma coleção só era
          // encontrada por quem já sabia que ela existia, e em tela de toque não
          // aparecia nunca.
          className="size-7 shrink-0 opacity-50 transition-opacity group-hover:opacity-100 focus-visible:opacity-100 data-[state=open]:opacity-100"
          aria-label={`Ações da coleção ${collection.collection_id}`}
        >
          <MoreVertical className="size-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          className="text-destructive data-highlighted:bg-destructive/10 data-highlighted:text-destructive"
          onClick={() => onRequestDelete(collection)}
        >
          <Trash2 />
          Remover coleção
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
